import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'http://localhost:8000/api',
  timeout: 10000,
});

export interface CUFGenerationData {
  date: string;
  generation_kwh: number;
  cuf: number;
  is_anomaly: boolean;
}

export interface CUFAnomalyData {
  date: string;
  block_id: string;
  generation_kwh: number;
  cuf: number;
  anomaly_type: 'cuf_drop' | 'zero_generation' | 'flatline';
}

class CUFGenerationService {
  async getBlockPerformance(blockId: string, dateRange?: string): Promise<CUFGenerationData[]> {
    const params = new URLSearchParams();
    if (blockId) params.append('block_id', blockId);
    if (dateRange) params.append('date_range', dateRange);
    
    const response = await apiClient.get(`/monitoring/block-cuf/performance/?${params}`);
    return response.data;
  }

  async getCUFAnomalies(blockId?: string): Promise<CUFAnomalyData[]> {
    // Return mock anomalies
    return [
      { date: '2024-10-04', block_id: 'BLOCK-4C-DI', generation_kwh: 0, cuf: 0, anomaly_type: 'zero_generation' },
      { date: '2024-10-08', block_id: 'BLOCK-4C-DI', generation_kwh: 920.7, cuf: 14.2, anomaly_type: 'cuf_drop' }
    ];
  }

  async getTestData(): Promise<CUFGenerationData[]> {
    // Return mock data directly
    return [
      { date: '2024-10-01', generation_kwh: 1050.2, cuf: 21.8, is_anomaly: false },
      { date: '2024-10-02', generation_kwh: 980.5, cuf: 20.3, is_anomaly: false },
      { date: '2024-10-03', generation_kwh: 1120.1, cuf: 23.1, is_anomaly: false },
      { date: '2024-10-04', generation_kwh: 0, cuf: 0, is_anomaly: true },
      { date: '2024-10-05', generation_kwh: 995.8, cuf: 20.6, is_anomaly: false },
      { date: '2024-10-06', generation_kwh: 1075.3, cuf: 22.2, is_anomaly: false },
      { date: '2024-10-07', generation_kwh: 890.4, cuf: 18.4, is_anomaly: false },
      { date: '2024-10-08', generation_kwh: 920.7, cuf: 14.2, is_anomaly: true },
      { date: '2024-10-09', generation_kwh: 1040.1, cuf: 21.5, is_anomaly: false },
      { date: '2024-10-10', generation_kwh: 1085.6, cuf: 22.4, is_anomaly: false }
    ];
  }
}

export const cufGenerationService = new CUFGenerationService();